import React, { useState, useEffect } from 'react';
import getBadgesData from 'components/Common/BadgesData';
import moment from 'moment';
import { Link } from 'react-router-dom';
import {
	Card,
	CardFooter,
	CardHeader,
	Row,
	Col,
	CardBody,
	Accordion,
	UncontrolledAccordion,
	AccordionItem,
	AccordionHeader,
	AccordionBody
} from 'reactstrap';
import CountryFlag from 'common/countryFlag';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import getShippingLineLinkUrl from 'helpers/shipping_line_url';
import { taskBadges } from 'constants/layout';
import { useDispatch } from 'react-redux';
import { setSelectedBooking } from 'store/actions';

const BookingCard = props => {
	let data = { ...props.bookingData };
	const [assignedUserDetails, setAssigedUserDetails] = useState({});

	let totaldayscount = 0;
	let passedDays = 0;

	var startDate = moment(data.etdDate);
	var endDate = moment(data.etaDate);
	var currentDate = moment();
	var result = endDate.diff(startDate, 'days');
	var difffromtoday = currentDate.diff(startDate, 'days');
	var remainingDays = startDate.diff(currentDate, 'days');
	var remaingDaysfrometa = endDate.diff(currentDate, 'days');

	const dispatch = useDispatch();

	if (result > 0) {
		totaldayscount = result;
	}
	if (difffromtoday > 0) {
		passedDays = difffromtoday;
	}

	const LayoutProperties = createSelector(
		state => state.Layout,
		layout => ({
			layoutType: layout.layoutModeType
		})
	);

	const { layoutType } = useSelector(LayoutProperties);

	useEffect(() => {
		if (props?.internalUsersList && props?.internalUsersList?.length > 0) {
			let bookingUser = {};
			let accountUser = {};
			if (data?.handlingOpertationUserId) {
				bookingUser = props.internalUsersList.find(item => item._id == data?.handlingOpertationUserId);
			}
			if (data?.handlingAccountUserId) {
				accountUser = props.internalUsersList.find(item => item._id == data?.handlingAccountUserId);
			}
			setAssigedUserDetails({ bookingUser, accountUser });
		}
	}, [props.internalUsersList]);

	return (
		<Card className={props.selectedBookingId == data._id ? 'bg-dark text-white overflow-hidden' : 'overflow-hidden'}>
			<CardBody className="pt-0 ">
				<Row className="mt-3">
					<Col xs="8" style={{ textAlign: 'left' }}>
						<h4 className="mb-sm-0 font-size-15">
							# {data.bookingNumber}
							<Link
								to={`/booking-details/${data.bookingNumber}`}
								onClick={() => dispatch(setSelectedBooking(data._id))}
								className={
									props.selectedBookingId == data._id
										? 'ms-2 hover-cursor-pointer text-white'
										: 'ms-2 hover-cursor-pointer text-dark'
								}
							>
								<i className="fa fa-eye ms-2 hover-cursor-pointer"></i>
							</Link>
						</h4>

						{data?.customerReferenceNumber && data?.customerReferenceNumber != '' ? (
							<div className="font-size-12 mt-2 mb-1">
								<span className="mt-2 font-size-12">Customer Ref No : </span> {data.customerReferenceNumber}
							</div>
						) : (
							<></>
						)}
					</Col>
					<Col xs="4" style={{ textAlign: 'right' }}>
						{data?.bookingType && getBadgesData(data?.bookingType)} {getBadgesData(data.bookingStatus)}
					</Col>
				</Row>
				<Row>
					<Col xs="12" className="text-left">
						<div className="mt-2 font-size-10">
							<span> Containers </span>
							<span>: {data.noOfContainer}</span>
							&nbsp;| Shipping Line :{' '}
							<b>{getShippingLineLinkUrl(data.shippingLineData?.companyname, data.bookingNumber)}</b>
						</div>
					</Col>
				</Row>
				<div>
					<Row className="mt-4">
						<Col xs="2" className="mt-3 text-center" style={{ height: '130px' }}>
							{data.loadingLocation !== '' ? (
								<>
									<div className="font-size-10 mt-3">Loading Point</div>
									<div className="font-size-10 vertical-align-center text-center justify-content-center align-items-center mt-2">
										<b>{data.loadingLocation}</b>
									</div>
								</>
							) : null}
						</Col>
						<Col
							xs="8"
							style={
								layoutType === 'dark' || props.selectedBookingId == data._id
									? { height: '135px', backgroundColor: 'rgb(34 39 54)', borderRadius: '10px' }
									: { height: '135px', backgroundColor: '#e0e5fb', borderRadius: '10px' }
							}
						>
							<Row>
								<Col xs="6" style={{ paddingLeft: '15px' }}>
									<div className="font-size-10 mt-3">Port of loading</div>
									<div>
										<b className="font-size-10">
											{data.polLocation} {CountryFlag[data.polCountry.toLowerCase()]}
										</b>
										<br />
										<span className="font-size-10">Departing {moment(data.etdDate).format('DD-MM-YYYY')}</span>
									</div>
								</Col>
								<Col xs="6" style={{ textAlign: 'right', paddingRight: '15px' }}>
									<div className="font-size-10 mt-3">Port of discharge</div>
									<div>
										<b className="font-size-10">
											{data.podLocation} {CountryFlag[data.podCountry.toLowerCase()]}
										</b>
										<br />
										<span className="font-size-10">Arriving {moment(data.etaDate).format('DD-MM-YYYY')}</span>
									</div>
								</Col>
							</Row>
							<div className="text-center justify-content-center align-items-center">
								{totaldayscount > 0 ? (
									<table className="align-middle mt-2 text-center">
										<tbody>
											<tr>
												{[...Array(totaldayscount).keys()].map((count, index) => {
													let eachday = count + 1;
													let selectedColor = '#fff';

													if (eachday <= passedDays) {
														selectedColor = '#464646';
													}
													return (
														<td
															key={index + 'days' + count}
															style={{
																display: 'table-cell',
																border: '1px #d1d1d1 solid',
																height: '12px',
																lineHeight: '1',
																overflow: 'hidden',
																padding: '0',
																textAlign: 'center',
																width: '10px',
																backgroundColor: selectedColor
															}}
														></td>
													);
												})}
												<td></td>
											</tr>
										</tbody>
									</table>
								) : null}
							</div>
							<div className="text-center font-size-10 w-100 mt-2">
								Total <b>{totaldayscount}</b> Days
							</div>
						</Col>
						<Col xs="2" className="mt-3 text-center" style={{ height: '130px' }}>
							{data.fpodLocation !== '' && data.fpodLocation !== data.podLocation ? (
								<>
									<div className="font-size-10 mt-3">Place of delivery</div>
									<div className="font-size-10 vertical-align-center text-center justify-content-center align-items-center mt-2">
										<b>{data.fpodLocation}</b>
									</div>
								</>
							) : null}
						</Col>
					</Row>
				</div>

				<UncontrolledAccordion stayOpen className="mt-3">
					{data?.profitData && (
						<AccordionItem>
							<AccordionHeader targetId={data.bookingNumber + '_1'}>
								<Row className="w-100">
									<Col>
										<h5 className="font-size-12">
											Finance Data ({data?.profitData?.length > 0 ? data?.profitData[0]?.parties?.length : 0})
										</h5>
									</Col>
									<Col>
										<div className="text-sm-end">
											<h5 className="font-size-12">
												Account User :{' '}
												{data?.handlingAccountUserId &&
												assignedUserDetails &&
												assignedUserDetails?.accountUser &&
												assignedUserDetails?.accountUser?.firstname
													? assignedUserDetails?.accountUser?.firstname?.toUpperCase() +
													  ' ' +
													  assignedUserDetails?.accountUser?.lastname?.toUpperCase()
													: 'Not Assigned'}
											</h5>
										</div>
									</Col>
								</Row>
							</AccordionHeader>
							<AccordionBody accordionId={data.bookingNumber + '_1'}>
								{data?.profitData?.length > 0 && (
									<Row>
										{data?.profitData[0]?.parties?.map(
											(item, index) =>
												item?.partyModel == 'TraxaaClient' && (
													<Col md="6" key={index} className="text-center mt-3">
														<h4 className="font-size-10">{item?.partyName}</h4>
														<div className="list-inline text-center">
															{item?.status == 'Profit' ? (
																<span className="badge bg-success p-1 list-inline-item">Profit</span>
															) : (
																<span className="badge bg-danger p-1 list-inline-item">Loss</span>
															)}
															<h5 className="list-inline-item font-size-10">
																{item?.currency} {parseFloat(item?.amount).toFixed(2)}
															</h5>
														</div>
													</Col>
												)
										)}
									</Row>
								)}
							</AccordionBody>
						</AccordionItem>
					)}
					{data?.tasksData && (
						<AccordionItem>
							<AccordionHeader targetId={data.bookingNumber + '_2'}>
								<Row className="w-100">
									<Col>
										<h5 className="font-size-12">
											Operation Task ({data?.tasksData?.length > 0 ? data?.tasksData[0]?.tasks?.length : 0})
										</h5>
									</Col>
									<Col>
										<div className="text-sm-end">
											<h5 className="font-size-12">
												Operation User :{' '}
												{data?.handlingOpertationUserId &&
												assignedUserDetails &&
												assignedUserDetails?.bookingUser &&
												assignedUserDetails?.bookingUser?.firstname
													? assignedUserDetails?.bookingUser?.firstname?.toUpperCase() +
													  ' ' +
													  assignedUserDetails?.bookingUser?.lastname?.toUpperCase()
													: 'Not Assigned'}
											</h5>
										</div>
									</Col>
								</Row>
							</AccordionHeader>
							<AccordionBody accordionId={data.bookingNumber + '_2'}>
								{data?.tasksData?.length > 0 && (
									<Row>
										{data?.tasksData[0]?.tasks?.map((item, index) => (
											<Col md="4" key={index} className="text-center mt-2 mb-3 font-size-10">
												<h4 className="font-size-10">{item.name}</h4>
												<span className="font-size-10">
													{moment(item?.startDate?.split('T')[0]).format('DD-MM-YYYY')}
												</span>
												{item?.dueDate != item.startDate && (
													<span className="font-size-10">
														{' '}
														- {moment(item?.dueDate?.split('T')[0]).format('DD-MM-YYYY')}
													</span>
												)}
												<br />
												<span
													className={`badge badge-soft mt-1 font-size-10 ${
														{
															...taskBadges
														}[item?.currentStatusValue]
													}`}
												>
													{item?.currentStatusValue}
												</span>
											</Col>
										))}
									</Row>
								)}
							</AccordionBody>
						</AccordionItem>
					)}
				</UncontrolledAccordion>
			</CardBody>
		</Card>
	);
};

export default BookingCard;
